import { FC, HTMLAttributes, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { MenuItem } from '../MenuItem/MenuItem';
import { StyledMenuItemList } from './MenuItemList.styles';

type DivProps = HTMLAttributes<HTMLDivElement>;
type Props = {
    items?: NavigationItem[];
    displayOption?: NavigationItem['displayOption'];
} & DivProps;

export const MenuItemList: FC<Props> = ({ items, displayOption, ...divProps }) => {
    const [open, setOpen] = useState<false | string>(false);

    const handleOpenChange = (title: string) => {
        setOpen((prevState) => (prevState === title ? false : title));
    };

    return (
        <StyledMenuItemList $displayOption={displayOption} {...divProps}>
            {items?.map((item, index) => (
                <MenuItem
                    open={open === item.title}
                    onOpenChange={() => handleOpenChange(item.title)}
                    key={`${item.title}-${index}`}
                    item={item}
                />
            ))}
        </StyledMenuItemList>
    );
};
